import React from 'react';
import EditLocation from './components/editLocation/EditLocation';

function EditLocationPage() {
  return <EditLocation />;
}

export default EditLocationPage;
